import {ConfEnv} from "../../../../config/config";
import publicRequest from "../../../../Infra/http/public.request";

/**
 * Fetch all available lottery games from the public API endpoint
 * Returns a simplified list of games with id, name, and logo
 * This endpoint does not require authentication
 */
export const getPublicLotteryGamesService = () => {
  return publicRequest.get(`${ConfEnv.BASE_URL}/public/lottery/games`);
};
